(function () {
  // Endpoint + public token come from snippets/storefront-api.liquid, rendered in <head>.
  const STOREFRONT = window.EnrouteStorefront || {};
  const CELEBRITY_PICK_TERM = "celebrity pick";
  const CELEBRITY_PICK_FILTER = 'tag:"celebrity pick"';
  // How many product cards render immediately (search page + popup); the rest stream in after.
  const SEARCH_FIRST_BATCH_SIZE = 4;

  const SEARCH_PAGE_REDIRECTS = new Map([
    ["order", "my-orders"],
    ["orders", "my-orders"],
    ["track", "track-your-order"],
    ["shipping", "shipping"],
    ["return", "shipping"],
    ["jewelry care", "jewelry-care"],
    ["size guide", "size-guide"],
    ["redeem","rewards"],
    ["membership","rewards"],
    ["rewards","rewards"]
  ]);

  function redirectSearchPage(core, query, immediate = false) {
    const term = (query || "").trim().toLowerCase().replace(/\s+/g, " ");
    const handle = SEARCH_PAGE_REDIRECTS.get(term);
    if (!handle) return false;

    const navigate = () => {
      const root = (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");
      window.location.href = new URL(`${root}pages/${handle}`, window.location.origin).toString();
    };
    if (immediate) {
      core.clearPending();
      navigate();
    } else {
      core.schedule(navigate);
    }
    return true;
  }

  function isCelebrityPickQuery(query) {
    return (query || "").trim().toLowerCase() === CELEBRITY_PICK_TERM;
  }

  // Exact-match category terms (singular) that should show their master collection's own
  // products directly, instead of the Storefront API's fuzzy predictive-search collection
  // list (which surfaces many loosely-related sub-collections — see assets/search.js history).
  // Plural forms ("necklaces") resolve to the same entry by stripping a trailing "s" below —
  // that heuristic only holds for English, so non-English plurals are listed explicitly.
  const CATEGORY_COLLECTION_MAP = {
    "necklace": "necklaces",
    "ring": "rings",
    "earring": "earrings",
    "bracelet": "bracelets",
    "anklet": "anklet",
    "gold necklace": "gold-necklace",
    "silver necklace": "silver-necklace",
    "gold ring": "gold-rings",
    "silver ring": "silver-rings",
    "gold earring": "gold-earrings",
    "silver earring": "silver-rings",
    "bangle": "bangles",
    "set": "jewelry-set",
    "jewelry set": "jewelry-set",

    // de (German)
    "halskette": "necklaces",
    "halsketten": "necklaces",
    "ringe": "rings",
    "ohrring": "earrings",
    "ohrringe": "earrings",
    "armband": "bracelets",
    "armbänder": "bracelets",
    "fußkette": "anklet",
    "fußketten": "anklet",
    "armreif": "bangles",
    "armreifen": "bangles",
    "schmuckset": "jewelry-set",
    "schmuckgarnitur": "jewelry-set",
    "goldkette": "gold-necklace",
    "goldene halskette": "gold-necklace",
    "silberkette": "silver-necklace",
    "silberne halskette": "silver-necklace",
    "goldring": "gold-rings",
    "goldringe": "gold-rings",
    "silberring": "silver-rings",
    "silberringe": "silver-rings",
    "goldohrring": "gold-earrings",
    "goldohrringe": "gold-earrings",
    "silberohrring": "silver-rings",
    "silberohrringe": "silver-rings",

    // es (Spanish)
    "collar": "necklaces",
    "collares": "necklaces",
    "anillo": "rings",
    "anillos": "rings",
    "pendiente": "earrings",
    "pendientes": "earrings",
    "arete": "earrings",
    "aretes": "earrings",
    "pulsera": "bracelets",
    "pulseras": "bracelets",
    "tobillera": "anklet",
    "tobilleras": "anklet",
    "brazalete": "bangles",
    "brazaletes": "bangles",
    "conjunto": "jewelry-set",
    "conjuntos": "jewelry-set",
    "juego de joyas": "jewelry-set",
    "set de joyas": "jewelry-set",
    "collar de oro": "gold-necklace",
    "collar de plata": "silver-necklace",
    "anillo de oro": "gold-rings",
    "anillo de plata": "silver-rings",
    "pendiente de oro": "gold-earrings",
    "arete de oro": "gold-earrings",
    "pendiente de plata": "silver-rings",
    "arete de plata": "silver-rings",

    // fr (French)
    "collier": "necklaces",
    "colliers": "necklaces",
    "bague": "rings",
    "bagues": "rings",
    "boucle d'oreille": "earrings",
    "boucles d'oreille": "earrings",
    "boucles d'oreilles": "earrings",
    "bracelet de cheville": "anklet",
    "bracelets de cheville": "anklet",
    "jonc": "bangles",
    "joncs": "bangles",
    "parure": "jewelry-set",
    "parures": "jewelry-set",
    "ensemble de bijoux": "jewelry-set",
    "collier en or": "gold-necklace",
    "collier or": "gold-necklace",
    "collier en argent": "silver-necklace",
    "collier argent": "silver-necklace",
    "bague en or": "gold-rings",
    "bague en argent": "silver-rings",
    "boucle d'oreille en or": "gold-earrings",
    "boucle d'oreille en argent": "silver-rings",

    // it (Italian)
    "collana": "necklaces",
    "collane": "necklaces",
    "anello": "rings",
    "anelli": "rings",
    "orecchino": "earrings",
    "orecchini": "earrings",
    "braccialetto": "bracelets",
    "braccialetti": "bracelets",
    "cavigliera": "anklet",
    "cavigliere": "anklet",
    "bracciale": "bangles",
    "bracciali": "bangles",
    "completo di gioielli": "jewelry-set",
    "collana d'oro": "gold-necklace",
    "collana in oro": "gold-necklace",
    "collana d'argento": "silver-necklace",
    "collana in argento": "silver-necklace",
    "anello d'oro": "gold-rings",
    "anello d'argento": "silver-rings",
    "orecchino d'oro": "gold-earrings",
    "orecchino d'argento": "silver-rings",

    // pl (Polish)
    "naszyjnik": "necklaces",
    "naszyjniki": "necklaces",
    "pierścionek": "rings",
    "pierścionki": "rings",
    "kolczyk": "earrings",
    "kolczyki": "earrings",
    "bransoletka": "bracelets",
    "bransoletki": "bracelets",
    "bransoletka na kostkę": "anklet",
    "bransoletki na kostkę": "anklet",
    "bransoleta": "bangles",
    "bransolety": "bangles",
    "komplet": "jewelry-set",
    "komplety": "jewelry-set",
    "zestaw biżuterii": "jewelry-set",
    "złoty naszyjnik": "gold-necklace",
    "srebrny naszyjnik": "silver-necklace",
    "złoty pierścionek": "gold-rings",
    "srebrny pierścionek": "silver-rings",
    "złoty kolczyk": "gold-earrings",
    "srebrny kolczyk": "silver-rings",

    // ja (Japanese)
    "ネックレス": "necklaces",
    "リング": "rings",
    "指輪": "rings",
    "イヤリング": "earrings",
    "ピアス": "earrings",
    "ブレスレット": "bracelets",
    "アンクレット": "anklet",
    "バングル": "bangles",
    "セット": "jewelry-set",
    "ジュエリーセット": "jewelry-set",
    "ゴールドネックレス": "gold-necklace",
    "シルバーネックレス": "silver-necklace",
    "ゴールドリング": "gold-rings",
    "シルバーリング": "silver-rings",
    "ゴールドイヤリング": "gold-earrings",
    "ゴールドピアス": "gold-earrings",
    "シルバーイヤリング": "silver-rings",
    "シルバーピアス": "silver-rings",

    // ko (Korean)
    "목걸이": "necklaces",
    "반지": "rings",
    "귀걸이": "earrings",
    "팔찌": "bracelets",
    "발찌": "anklet",
    "뱅글": "bangles",
    "세트": "jewelry-set",
    "주얼리 세트": "jewelry-set",
    "골드 목걸이": "gold-necklace",
    "실버 목걸이": "silver-necklace",
    "골드 반지": "gold-rings",
    "실버 반지": "silver-rings",
    "골드 귀걸이": "gold-earrings",
    "실버 귀걸이": "silver-rings",
  };

  function resolveCategoryCollectionHandle(query) {
    const term = (query || "").trim().toLowerCase();
    if (!term) return null;
    if (CATEGORY_COLLECTION_MAP[term]) return CATEGORY_COLLECTION_MAP[term];
    if (term.endsWith("s") && CATEGORY_COLLECTION_MAP[term.slice(0, -1)]) {
      return CATEGORY_COLLECTION_MAP[term.slice(0, -1)];
    }
    return null;
  }

  function isCategoryQuery(query) {
    return resolveCategoryCollectionHandle(query) !== null;
  }

  // Merchant-curated collection grids (merchandising spec, Nov 2026). Keys are exact
  // search terms (lowercase, single spaces — no plural-stripping, "ring" and "rings"
  // pin different lists); values are live collection handles, verified against the
  // storefront. A matched term replaces the Storefront API's fuzzy predictive-search
  // collection list with exactly these collections, in this order. Terms absent from
  // this map keep the default predictive behavior.
  const CURATED_COLLECTION_LISTS = {
    "rings": ["gold-rings", "statement-rings", "stackable-rings", "silver-rings"],
    "ring": ["body-jewelry", "hand-chains"],
    "necklace": ["silver-collection", "silver-necklace", "silver-earrings-1", "silver-rings", "silver-bangles"],
    "earrings": ["gold-earrings", "dangle-earrings", "silver-earrings-1", "statement-earrings", "hoop-earrings"],
    "bracelet": ["bracelet-anklet", "rings-and-bracelets", "gold-bracelets-1", "silver-bracelets-for-women"],
    "bangle": ["heart-jewelry"],
    "anklet": ["choker-necklace"],
    "choker": ["body-jewelry"],
    "waterproof": ["gold-necklace", "silver-necklace", "pendant-necklaces-1", "chain-necklace", "statement-necklaces", "lariat-necklace", "cord-necklace", "pearl-necklace", "choker-necklace", "layered-necklace"],
    "collier": ["gold-necklace", "silver-necklace", "pendant-necklaces-1", "chain-necklace", "statement-necklaces", "lariat-necklace", "cord-necklace", "pearl-necklace", "choker-necklace", "layered-necklace"],
    "gold": ["gold-necklace", "gold-earrings", "gold-rings", "gold-bracelets-1"],
    "silver": ["waterproof-jewelry"],
    "hand chain": ["gold-rings", "statement-rings", "stackable-rings", "silver-rings"],
    "cross": ["cross-jewelry"],
    "cross necklace": ["cross-jewelry"],
    "pearl": ["body-jewelry"],
    "fish": ["pearl-collection"],
    "belly": ["star-collection"],
    "belly ring": ["the-waterdrop-collection"],
    "waterdrop": ["body-jewelry"],
    "orchid": ["body-jewelry", "waist-chains"],
    "lighter": ["body-jewelry", "waist-chains"],
    "helix": ["hoop-earrings"],
    "hand": ["hoop-earrings"],
    "hoop": ["arm-cuffs"],
    "piercing": ["lariat-necklace"],
    "athena": ["jewelry-set"],
    "ear cuff": ["gold-necklace", "gold-earrings", "gold-rings", "gold-bracelets-1"],
    "carnelian": ["carnelian-collection"],
    "orin": ["customized-jewelry"],
    "birthstone": ["bracelet-anklet", "rings-and-bracelets", "gold-bracelets-1", "silver-bracelets-for-women"],
    "petra": ["gold-earrings", "dangle-earrings", "silver-earrings-1", "statement-earrings", "hoop-earrings"],
  };

  // Returns the curated list for an exact term match, shaped like predictive-search
  // collections ({ handle } is all the card renderer needs), or null to keep the
  // predictive list. Curated entries deliberately skip the image/exclude metafield
  // filters applied to predictive results — the list is explicit merchandising intent.
  function resolveCuratedCollections(query) {
    const term = (query || "").trim().toLowerCase().replace(/\s+/g, " ");
    const handles = CURATED_COLLECTION_LISTS[term];
    return handles ? handles.map((handle) => ({ handle })) : null;
  }

  const PRODUCT_FIELDS = `
    handle
    title
    tags
    createdAt
  `;

  const COLLECTION_FIELDS = `
    handle
    title
    image { url }
    excludeMetafield: metafield(namespace: "custom", key: "exclude_from_search_and_suggestions") { value }
  `;

  const PAGE_SEARCH_QUERY = `
    query PageSearch($query: String!, $first: Int!, $after: String, $withCollections: Boolean!, $country: CountryCode, $language: LanguageCode)
    @inContext(country: $country, language: $language) {
      productSearch: search(query: $query, first: $first, after: $after, types: [PRODUCT], prefix: LAST, unavailableProducts: SHOW) {
        totalCount
        pageInfo { hasNextPage endCursor }
        edges {
          node {
            ... on Product { ${PRODUCT_FIELDS} }
          }
        }
      }
      predictiveSearch(query: $query, limit: 10, types: [COLLECTION], unavailableProducts: SHOW) @include(if: $withCollections) {
        collections { ${COLLECTION_FIELDS} }
      }
    }
  `;

  const CELEBRITY_PICK_QUERY = `
    query CelebrityPickProducts($query: String!, $first: Int!, $after: String, $country: CountryCode, $language: LanguageCode)
    @inContext(country: $country, language: $language) {
      productSearch: products(query: $query, first: $first, after: $after, sortKey: BEST_SELLING) {
        pageInfo { hasNextPage endCursor }
        edges {
          node { ${PRODUCT_FIELDS} }
        }
      }
      productCount: search(query: $query, first: 1, types: [PRODUCT], unavailableProducts: SHOW) {
        totalCount
      }
    }
  `;

  const SUGGEST_QUERY = `
    query SuggestQueries($query: String!, $country: CountryCode, $language: LanguageCode)
    @inContext(country: $country, language: $language) {
      predictiveSearch(query: $query, types: [QUERY], unavailableProducts: SHOW) {
        queries { text styledText }
      }
    }
  `;

  const BESTSELLER_QUERY = `
    query BestsellerFallback($country: CountryCode, $language: LanguageCode)
    @inContext(country: $country, language: $language) {
      collection(handle: "bestseller") {
        products(first: 12) {
          nodes { ${PRODUCT_FIELDS} }
        }
      }
    }
  `;

  function getStorefrontContext() {
    return {
      country: (window.Shopify?.country || "US").toUpperCase(),
      language: (window.Shopify?.locale || "en").toUpperCase().replace("-", "_"),
    };
  }

  async function storefrontFetch(query, variables, signal) {
    const response = await fetch(STOREFRONT.url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT.token,
      },
      body: JSON.stringify({ query, variables: { ...variables, ...getStorefrontContext() } }),
      signal,
    });
    const { data, errors } = await response.json();
    if (errors?.length) throw new Error(errors[0].message);
    return data;
  }

  async function fetchSectionCard(path, sectionId, signal, requiredSelector) {
    const url = new URL((window.Shopify?.routes?.root || "/") + path, window.location.origin);
    url.searchParams.set("section_id", sectionId);

    let response;
    try {
      response = await fetch(url.toString(), { signal });
    } catch (error) {
      if (error.name === "AbortError") throw error;
      return null;
    }

    if (!response.ok) return null;

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const wrapper = doc.getElementById(`shopify-section-${sectionId}`) || doc.body;

    if (requiredSelector && !wrapper.querySelector(requiredSelector)) return null;

    // Fallback: when the product is not available in the online store, the section still renders but .title strong is empty
    const titleEl = wrapper.querySelector(".title strong");
    if (titleEl && !titleEl.textContent.trim()) return null;

    return wrapper.innerHTML.trim();
  }

  function fetchCollectionCard(handle, signal) {
    return fetchSectionCard(`collections/${handle}`, "search-collection-card", signal);
  }

  // Renders the market-resolved collection's own product handles (see
  // sections/search-category-collection.liquid), so a category-term search can reuse the
  // exact market/shadow-collection logic from default-collection-v2.liquid without
  // duplicating it client-side. `page` is a 1-based collection page number, matching the
  // pagination already used by snippets/more-loader.liquid.
  async function fetchCategoryCollectionPage(handle, page, signal) {
    const url = new URL((window.Shopify?.routes?.root || "/") + `collections/${handle}`, window.location.origin);
    url.searchParams.set("section_id", "search-category-collection");
    if (page > 1) url.searchParams.set("page", page);

    let response;
    try {
      response = await fetch(url.toString(), { signal });
    } catch (error) {
      if (error.name === "AbortError") throw error;
      return { productHandles: [], hasNextPage: false, totalCount: 0 };
    }

    if (!response.ok) return { productHandles: [], hasNextPage: false, totalCount: 0 };

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const productHandles = [...doc.querySelectorAll("[data-search-category-product]")]
      .map((el) => el.dataset.handle)
      .filter(Boolean);
    const meta = doc.querySelector("[data-search-category-meta]");
    return {
      productHandles,
      hasNextPage: meta?.dataset.hasNextPage === "true",
      totalCount: parseInt(meta?.dataset.totalCount || "0", 10),
    };
  }

  // Batch-render product cards in one request. The Section Rendering API can't take
  // arbitrary params, so handles ride in the search query (`?q=`) and are read back
  // in Liquid via `search.terms`. `all_products` caps at 20 handles/request, so chunk.
  // Returns an array of card HTML strings, search order preserved.
  async function fetchProductCardsBatch(handles, sectionId, signal) {
    if (!handles.length) return [];
    const chunks = [];
    for (let i = 0; i < handles.length; i += 20) chunks.push(handles.slice(i, i + 20));
    const groups = await Promise.all(chunks.map((chunk) => fetchBatchSection(chunk, sectionId, signal)));
    return groups.flat();
  }

  async function fetchBatchSection(handles, sectionId, signal) {
    const url = new URL((window.Shopify?.routes?.root || "/") + "search", window.location.origin);
    url.searchParams.set("q", handles.join(" "));
    url.searchParams.set("section_id", sectionId);

    let response;
    try {
      response = await fetch(url.toString(), { signal });
    } catch (error) {
      if (error.name === "AbortError") throw error;
      return [];
    }

    if (!response.ok) return [];

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const wrapper = doc.getElementById(`shopify-section-${sectionId}`) || doc.body;
    return [...wrapper.querySelectorAll("[data-search-card]")].map((el) => el.innerHTML.trim());
  }

  // if multiple products have the same title, pick the earliest to represent them in the search results
  function pickRepresentative(product, products) {
    const sameTitle = products.filter((item) => item.title === product.title);
    let pick = sameTitle.find((item) => (item.tags || []).includes("popular_product"));
    if (!pick) {
      pick = sameTitle.reduce((oldest, item) => {
        if (!oldest) return item;
        return new Date(item.createdAt) < new Date(oldest.createdAt) ? item : oldest;
      }, null);
    }
    return pick || product;
  }

  function pickProducts(products, limit) {
    const chosen = [];
    const renderedTitles = new Set();
    let rescount = limit != null ? Math.min(products.length, limit) : products.length;

    for (const product of products) {
      const pick = pickRepresentative(product, products);
      const titleKey = `[${pick.title}]`;
      const excluded = (pick.tags || []).includes("exclude_search");
      const duplicate = renderedTitles.has(titleKey);

      if (!excluded && !duplicate) {
        chosen.push(pick);
        renderedTitles.add(titleKey);
        if (limit != null && chosen.length === limit) break;
      } else {
        rescount -= 1;
      }
    }

    return { chosen, rescount };
  }

  function appendProductCards(grid, cards, columnClass = "col-12-xs col-8-sm col-8-md col-6-xl") {
    cards.forEach((card) => {
      const item = document.createElement("div");
      item.className = columnClass;
      item.innerHTML = card;
      grid?.appendChild(item);
    });
  }

  // Streams the remainder of the current result set's cards into an already-rendered grid,
  // so the search page/popup can paint the first few cards without waiting on the rest.
  async function appendRemainingProductCards(grid, restProducts, sectionId, signal, columnClass) {
    if (!grid || !restProducts.length) return;
    try {
      const cards = await fetchProductCardsBatch(restProducts.map((product) => product.handle), sectionId, signal);
      appendProductCards(grid, cards.filter(Boolean), columnClass);
    } catch (error) {
      if (error.name === "AbortError") return;
      console.log("search page error", error);
    }
  }

  async function renderProductHandles(handles, translations, signal) {
    const cards = (await fetchProductCardsBatch(handles, "search-cards-batch-popup", signal))
      .filter(Boolean);
    let html = `<input type="hidden" value="${cards.length}" id="hvg-search-results-count"/>`;

    if (cards.length > 0) {
      html += `<div class="grid" data-search-popup-grid>`;
      cards.forEach((card) => {
        html += `<div class="col-12-xs col-8-sm col-6-md">${card}</div>`;
      });
      html += `</div>`;
    } else {
      html += `<div class="hvg-search-suggestions-title-nothing">${translations.nothingWithBonus}</div>`;
    }

    return { html, count: cards.length };
  }

  async function renderPopupResults(query, searchData, translations, signal, options = {}) {
    // Category-matched products (assets/search.js's CATEGORY_COLLECTION_MAP) come back
    // without title/tags (see SearchCore.fetchCategorySearch), so — like celebrity-pick
    // results — they skip pickProducts's title-based dedup, which would otherwise treat
    // every product as a duplicate of the same empty title.
    const isCelebrityPick = isCelebrityPickQuery(query);
    const isCategory = isCategoryQuery(query);
    const totalCount = searchData?.productSearch?.totalCount || 0;
    const products = (searchData?.productSearch?.edges || []).map((edge) => edge.node);
    const collections = resolveCuratedCollections(query)
      ?? (searchData?.predictiveSearch?.collections || [])
        .filter((collection) => collection.image?.url && collection.excludeMetafield?.value !== "true");

    let chosenProducts = [];
    let rescount = 0;
    if (totalCount > 0) {
      if (isCelebrityPick || isCategory) {
        chosenProducts = products.slice(0, 6);
        rescount = chosenProducts.length;
      } else {
        const picked = pickProducts(products, 6);
        chosenProducts = picked.chosen;
        rescount = picked.rescount;
      }
    }

    const firstBatch = chosenProducts.slice(0, SEARCH_FIRST_BATCH_SIZE);
    const restBatch = chosenProducts.slice(SEARCH_FIRST_BATCH_SIZE);
    const bestsellerProducts = totalCount === 0 ? searchData?.bestseller?.collection?.products?.nodes || [] : [];

    const [collectionCards, productCards, bestsellerCards] = (
      await Promise.all([
        Promise.all(options.productsOnly ? [] : collections.map((collection) => fetchCollectionCard(collection.handle, signal))),
        fetchProductCardsBatch(firstBatch.map((product) => product.handle), "search-cards-batch-popup", signal),
        fetchProductCardsBatch(bestsellerProducts.map((product) => product.handle), "search-cards-batch-popup", signal),
      ])
    ).map((cards) => cards.filter(Boolean));

    let html = "";

    if (!options.productsOnly && query.trim() && collections.length > 0) {
      const gridClass = collections.length > 6 ? "search-collection-grid-many" : `search-collection-grid-${collections.length}`;
      html += `<h3 class="search-subheader-popup">Collections</h3>`;
      html += `<div class="${gridClass}">`;
      collectionCards.forEach((card) => {
        html += `<div class="hvg-scroll">${card}</div>`;
      });
      html += `</div>`;
    }

    if (totalCount > 0) {
      if (!options.productsOnly) {
        const viewAllUrl = `${window.Shopify?.routes?.root || "/"}search?q=${encodeURIComponent(query)}&type=product&options[unavailable_products]=show&options[prefix]=last`;
        html += `<div class="search-results-heading"><h3 class="search-subheader-popup">Products</h3><a class="search-results-view-all" href="${viewAllUrl}">${translations.viewAll || "View All"}</a></div>`;
      }
      html += `<div class="grid" data-search-popup-grid>`;
      productCards.forEach((card) => {
        html += `<div class="col-12-xs col-8-sm col-6-md">${card}</div>`;
      });
      html += `</div>`;
    }

    html += `<input type="hidden" value="${totalCount}" id="hvg-search-results-count"/>`;

    if (!options.productsOnly && totalCount > 6) {
      const rescleft = totalCount - rescount;
      const url = `${window.Shopify?.routes?.root || "/"}search?q=${encodeURIComponent(query)}&type=product&options[unavailable_products]=show&options[prefix]=last`;
      html += `<div style="display: flex; justify-content: center; height: 50px;"><div style="width: 250px; display: flex; justify-content: center;"><a href="${url}" class="hvg-more-btn" style="">Load ${rescleft} more results</a></div></div>`;
    } else if (!options.productsOnly && rescount > 0) {
      html += `${rescount} products found.`;
    } else if (totalCount === 0) {
      html += `<div class="hvg-search-suggestions-title-nothing">${translations.nothingWithBonus}</div>`;
      if (bestsellerCards.length > 0) {
        html += `<div class="grid">`;
        bestsellerCards.forEach((card) => {
          html += `<div class="col-12-xs col-8-sm col-6-md">${card}</div>`;
        });
        html += `</div>`;
      }
    }


    return { html, restBatch };
  }

  async function renderPageResults(query, searchData, translations, signal) {
    const isCelebrityPick = isCelebrityPickQuery(query);
    const isCategory = isCategoryQuery(query);
    const totalCount = searchData?.productSearch?.totalCount || 0;
    const products = (searchData?.productSearch?.edges || []).map((edge) => edge.node);
    const collections = resolveCuratedCollections(query)
      ?? (searchData?.predictiveSearch?.collections || [])
        .filter((collection) => collection.image?.url && collection.excludeMetafield?.value !== "true")
        .slice(0, 24);

    const chosenProducts = totalCount > 0
      ? (isCelebrityPick || isCategory ? products : pickProducts(products, null).chosen)
      : [];
    const firstBatch = chosenProducts.slice(0, SEARCH_FIRST_BATCH_SIZE);
    const restBatch = chosenProducts.slice(SEARCH_FIRST_BATCH_SIZE);
    const bestsellerProducts = totalCount === 0 ? searchData?.bestseller?.collection?.products?.nodes || [] : [];

    const [collectionCards, productCards, bestsellerCards] = (
      await Promise.all([
        Promise.all(collections.map((collection) => fetchCollectionCard(collection.handle, signal))),
        fetchProductCardsBatch(firstBatch.map((product) => product.handle), "search-cards-batch", signal),
        fetchProductCardsBatch(bestsellerProducts.map((product) => product.handle), "search-cards-batch", signal),
      ])
    ).map((cards) => cards.filter(Boolean));

    let html = "";

    if (query.trim() && collections.length > 0) {
      const gridClass = collections.length > 6 ? "search-collection-grid-many" : `search-collection-grid-${collections.length}`;
      html += `<h3 class="search-subheader-popup">Collections</h3>`;
      html += `<div class="${gridClass}">`;
      collectionCards.forEach((card) => {
        html += `<div class="hvg-scroll">${card}</div>`;
      });
      html += `</div>`;
    }

    if (totalCount > 0) {
      html += `<div class="search-results-heading"><h3 class="search-subheader-popup">Products</h3></div>`;
    }

    html += `<input type="hidden" value="${totalCount}" id="hvg-search-results-count"/>`;

    if (totalCount > 0) {
      html += `<div class="grid hvg-product-listing hvg-grid" data-search-page-grid>`;
      productCards.forEach((card) => {
        html += `<div class="col-12-xs col-8-sm col-8-md col-6-xl">${card}</div>`;
      });
      html += `</div>`;

      const hasNextPage = !!searchData?.productSearch?.pageInfo?.hasNextPage;
      html += `<div data-search-page-load-more-wrapper style="display: ${hasNextPage ? "flex" : "none"}; justify-content: center; height: 50px;">`;
      html += `<div style="width: 250px; display: flex; justify-content: center;">`;
      html += `<button type="button" class="hvg-more-btn" data-search-page-load-more style="display: ${hasNextPage ? "inline-block" : "none"};">${translations.loadMore}</button>`;
      html += `<span class="loader-dot-hvg" data-search-page-loader style="display: none;"><i></i><i></i><i></i></span>`;
      html += `</div></div>`;
    } else {
      html += `<div class="hvg-search-suggestions-title-nothing">${translations.nothingWithBonus}</div>`;
      if (bestsellerCards.length > 0) {
        html += `<div class="grid hvg-product-listing hvg-grid">`;
        bestsellerCards.forEach((card) => {
          html += `<div class="col-12-xs col-8-sm col-8-md col-6-xl">${card}</div>`;
        });
        html += `</div>`;
      }
    }

    return { html, restBatch };
  }

  class SearchCore {
    constructor(options) {
      this.options = Object.assign(
        {
          debounceDelay: 180,
          productType: "product",
          unavailableProducts: "show",
          prefix: "last",
        },
        options || {}
      );
      this.abortController = null;
      this.debounceTimer = null;
    }

    clearPending() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }

      if (this.debounceTimer) {
        window.clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
    }

    schedule(callback) {
      this.clearPending();
      this.debounceTimer = window.setTimeout(() => {
        const controller = new AbortController();
        this.abortController = controller;
        callback(controller.signal);
      }, this.options.debounceDelay);
    }

    applySearchParams(url, query) {
      url.searchParams.set("q", query || "");
      url.searchParams.set("type", this.options.productType);
      url.searchParams.set("options[unavailable_products]", this.options.unavailableProducts);
      url.searchParams.set("options[prefix]", this.options.prefix);
      return url;
    }

    async fetchSection(query, sectionName, signal) {
      const url = this.applySearchParams(
        new URL(window.Shopify.routes.root + "search", window.location.origin),
        query
      );
      url.searchParams.set("sections", sectionName);
      const response = await fetch(url.toString(), { signal });
      return response.json();
    }

    async loadSuggestions(phrase) {
      if (!phrase || !phrase.trim()) return [];

      let parts = phrase.trim().split(/[\s_-]+/);
      do {
        const url = new URL(window.Shopify.routes.root + "search/suggest.json", window.location.origin);
        url.searchParams.set("q", parts.at(-1) || "");
        url.searchParams.set("resources[type]", "query,product");
        url.searchParams.set("resources[options][unavailable_products]", this.options.unavailableProducts);
        const response = await fetch(url.toString());
        const data = await response.json();
        const suggestions = data?.resources?.results?.queries || [];
        if (suggestions.length > 0) return suggestions;
        parts = parts.slice(0, -1);
      } while (parts.length > 0);

      return [];
    }

    trackSearchQuery(query, resultCount) {
      document.dispatchEvent(
        new CustomEvent("search_query", {
          detail: {
            search_query: query,
            search_result_count: resultCount,
          },
        })
      );
    }

    async fetchPopupSearch(query, signal) {
      if (isCelebrityPickQuery(query)) {
        return this.fetchCelebrityPickProducts(24, null, signal);
      }

      const categoryHandle = resolveCategoryCollectionHandle(query);
      if (categoryHandle) {
        return this.fetchCategorySearch(categoryHandle, null, signal);
      }

      const data = await storefrontFetch(
        PAGE_SEARCH_QUERY,
        { query, first: 24, after: null, withCollections: true },
        signal
      );
      if (data?.productSearch?.totalCount === 0) {
        const bestseller = await storefrontFetch(BESTSELLER_QUERY, {}, signal);
        data.bestseller = bestseller;
      }
      return data;
    }

    async fetchPageSearch(query, after, signal) {
      if (isCelebrityPickQuery(query)) {
        return this.fetchCelebrityPickProducts(20, after, signal);
      }

      const categoryHandle = resolveCategoryCollectionHandle(query);
      if (categoryHandle) {
        return this.fetchCategorySearch(categoryHandle, after, signal);
      }

      const data = await storefrontFetch(
        PAGE_SEARCH_QUERY,
        { query, first: 20, after: after || null, withCollections: !after },
        signal
      );
      if (!after && data?.productSearch?.totalCount === 0) {
        const bestseller = await storefrontFetch(BESTSELLER_QUERY, {}, signal);
        data.bestseller = bestseller;
      }
      return data;
    }

    async fetchCelebrityPickProducts(first, after, signal) {
      const data = await storefrontFetch(
        CELEBRITY_PICK_QUERY,
        { query: CELEBRITY_PICK_FILTER, first, after: after || null },
        signal
      );
      const connection = data?.productSearch;
      if (connection) {
        connection.totalCount = data?.productCount?.totalCount
          ?? connection.edges.length + (connection.pageInfo?.hasNextPage ? 1 : 0);
      }
      return data;
    }

    // Shapes a category collection's product handles (already market/shadow-resolved by
    // sections/search-category-collection.liquid) to look like a PAGE_SEARCH_QUERY response,
    // so renderPopupResults/renderPageResults and PredictiveSearchPage's load-more need no
    // extra branching. `after` doubles as a 1-based collection page number here (round-tripped
    // opaquely by the caller, same as a GraphQL cursor would be).
    async fetchCategorySearch(handle, after, signal) {
      const page = after ? parseInt(after, 10) : 1;
      const { productHandles, hasNextPage, totalCount } = await fetchCategoryCollectionPage(handle, page, signal);
      return {
        productSearch: {
          totalCount,
          pageInfo: { hasNextPage, endCursor: hasNextPage ? String(page + 1) : null },
          edges: productHandles.map((productHandle) => ({
            node: { handle: productHandle, title: "", tags: [], createdAt: "" },
          })),
        },
        predictiveSearch: { collections: [] },
      };
    }

    async fetchSuggestQueries(phrase, signal) {
      if (!phrase || !phrase.trim()) return [];

      let parts = phrase.trim().split(/[\s_-]+/);
      do {
        const data = await storefrontFetch(SUGGEST_QUERY, { query: parts.at(-1) || "" }, signal);
        const suggestions = data?.predictiveSearch?.queries || [];
        if (suggestions.length > 0) return suggestions;
        parts = parts.slice(0, -1);
      } while (parts.length > 0);

      return [];
    }

  }

  class SearchField extends HTMLElement {
    constructor() {
      super();
      this.composing = false;
      this.onInput = this.onInput.bind(this);
      this.onClear = this.onClear.bind(this);
      this.onCompositionStart = this.onCompositionStart.bind(this);
      this.onCompositionEnd = this.onCompositionEnd.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.input = this.querySelector("[data-search-input]");
      this.clearButton = this.querySelector("[data-search-clear]");
      this.suggestionsTitle = this.querySelector("[data-search-suggestions-title]");
      this.suggestionsPanel = this.querySelector("[data-search-suggestions-panel]");
      this.suggestionsList = this.querySelector("[data-search-suggestions-list]");

      if (!this.input) return;

      this.input.addEventListener("input", this.onInput);
      this.input.addEventListener("compositionstart", this.onCompositionStart);
      this.input.addEventListener("compositionend", this.onCompositionEnd);
      if (this.clearButton) {
        this.clearButton.addEventListener("click", this.onClear);
      }

      this.syncControls();
      this.clearSuggestions();
    }

    disconnectedCallback() {
      if (this.input) {
        this.input.removeEventListener("input", this.onInput);
        this.input.removeEventListener("compositionstart", this.onCompositionStart);
        this.input.removeEventListener("compositionend", this.onCompositionEnd);
      }
      if (this.clearButton) {
        this.clearButton.removeEventListener("click", this.onClear);
      }
    }

    get value() {
      return this.input ? this.input.value : "";
    }

    focus() {
      if (this.input) this.input.focus();
    }

    onCompositionStart() {
      this.composing = true;
    }

    // IME composition (Pinyin, Japanese, Korean, etc.) finished — the input events fired while
    // composing are ignored below, so fire the search exactly once here with the final text.
    onCompositionEnd() {
      this.composing = false;
      this.syncControls();
      this.finishInput();
    }

    onInput(event) {
      this.syncControls();
      // Mid-composition input events carry intermediate candidate text, not the shopper's
      // real query — don't start a search for every keystroke of an IME candidate.
      if (this.composing || event.isComposing) return;
      this.finishInput();
    }

    finishInput() {
      if (!this.value.trim()) {
        this.clearSuggestions();
      }
      this.dispatchInput();
    }

    onClear(event) {
      event.preventDefault();
      if (!this.input) return;
      this.input.value = "";
      this.syncControls();
      this.clearSuggestions();
      this.focus();
      this.dispatchInput();
    }

    dispatchInput() {
      this.dispatchEvent(
        new CustomEvent("search-field:input", {
          bubbles: true,
          detail: { value: this.value },
        })
      );
    }

    syncControls() {
      if (!this.clearButton) return;
      this.clearButton.hidden = this.value.length === 0;
    }

    clearSuggestions() {
      if (this.suggestionsTitle) this.suggestionsTitle.hidden = true;
      if (this.suggestionsPanel) this.suggestionsPanel.hidden = true;
      if (this.suggestionsList) this.suggestionsList.innerHTML = "";
    }

    renderSuggestions(items, options) {
      const settings = Object.assign({ appendSearchTrack: false }, options || {});

      if (!items || items.length === 0) {
        this.clearSuggestions();
        return;
      }

      if (this.suggestionsTitle) this.suggestionsTitle.hidden = false;
      if (this.suggestionsPanel) this.suggestionsPanel.hidden = false;
      if (!this.suggestionsList) return;

      this.suggestionsList.innerHTML = "";
      items.forEach((item) => {
        const listItem = document.createElement("li");
        listItem.className = "search-suggestions__item";

        const link = document.createElement("a");
        if (settings.appendSearchTrack) {
          const separator = item.url.includes("?") ? "&" : "?";
          link.href = item.url + separator + "search_track=1";
        } else {
          link.href = item.url;
        }
        link.innerHTML = item.styled_text;

        listItem.appendChild(link);
        this.suggestionsList.appendChild(listItem);
      });
    }
  }

  class PredictiveSearchPage extends HTMLElement {
    constructor() {
      super();
      this.core = new SearchCore();
      this.onFieldInput = this.onFieldInput.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onLoadMoreClick = this.onLoadMoreClick.bind(this);
      this.endCursor = null;
      this.hasNextPage = false;
      this.currentQuery = "";
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.form = this.querySelector("form");
      this.field = this.querySelector("search-field");
      this.results = document.querySelector(this.dataset.resultsTarget || "#search-page--result");
      this.skeletonHTML = this.querySelector("[data-search-skeleton]")?.innerHTML.trim() || "";
      this.useApiSearch = this.dataset.useApiSearch !== "false";
      this.translations = {
        nothingWithBonus: this.dataset.tNothingWithBonus || "",
        viewAll: this.dataset.tViewAll || "View All",
        loadMore: this.dataset.tLoadMore || "Load more",
      };

      if (!this.field || !this.results) {
        return;
      }

      this.field.addEventListener("search-field:input", this.onFieldInput);
      if (this.form) {
        this.form.addEventListener("submit", this.onSubmit);
      }

      // Read the initial term from the URL (`?q=`), not the input value. When a
      // parent app (the Vue instance on #app) re-renders this subtree, this element
      // can connect before the rebuilt input has its value populated, so `this.field.value`
      // may be transiently empty. The URL query is always present and never touched by
      // that re-render, so it survives the double-render regardless of script load order.
      const urlQuery = new URLSearchParams(window.location.search).get("q") || "";
      const initialQuery = urlQuery || this.field.value;
      if (initialQuery.trim()) {
        if (redirectSearchPage(this.core, initialQuery, true)) return;
        if (this.useApiSearch || isCelebrityPickQuery(initialQuery) || isCategoryQuery(initialQuery)) {
          this.runApiSearch(initialQuery);
        } else {
          this.runSectionSearch(initialQuery);
        }
      }
    }

    disconnectedCallback() {
      // Abort any in-flight search when this element is torn out (e.g. by the Vue
      // re-render of #app), so a detached instance can't finish and write results
      // into a now-orphaned node while the live instance handles the render.
      this.core.clearPending();
      if (this.field) {
        this.field.removeEventListener("search-field:input", this.onFieldInput);
      }
      if (this.form) {
        this.form.removeEventListener("submit", this.onSubmit);
      }
    }

    // Re-resolve the results container against the live document. A parent re-render
    // (the Vue instance on #app) can replace #search-page--result after we cached it in
    // connectedCallback, leaving this.results detached. Always resolve the node that is
    // currently in the document before writing, otherwise results land in an orphan node.
    refreshResults() {
      const live = document.querySelector(this.dataset.resultsTarget || "#search-page--result");
      if (live) this.results = live;
      return this.results;
    }

    // Replace the previous results with placeholder cards as soon as a new request starts,
    // so the shopper never sees stale results sitting under an already-changed query.
    showSkeleton() {
      if (!this.skeletonHTML) return;
      const results = this.refreshResults();
      if (results) results.innerHTML = this.skeletonHTML;
    }

    onSubmit(event) {
      event.preventDefault();
      redirectSearchPage(this.core, this.field.value, true);
    }

    // Drop a resolved request if the user has typed on since it started. Both sides are
    // trimmed: `requestedPhrase` is normalized by runApiSearch/runSectionSearch, while the
    // field value is whatever the shopper last typed (or Liquid's already-trimmed
    // `search.terms`), so only the trim makes `?q=foo+` match the field's "foo".
    isStale(requestedPhrase) {
      return !this.field || this.field.value.trim() !== requestedPhrase;
    }

    onFieldInput(event) {
      const phrase = event.detail.value;

      if (redirectSearchPage(this.core, phrase)) return;

      window.scrollTo(0, 0);
      this.updateHistory(phrase);

      if (this.useApiSearch || isCelebrityPickQuery(phrase) || isCategoryQuery(phrase)) {
        this.runApiSearch(phrase);
      } else {
        this.runSectionSearch(phrase);
      }
    }

    runApiSearch(phrase) {
      // Normalize once, here: the initial term comes from the URL (`?q=foo+` decodes to
      // "foo ") while later terms come straight from the input. Everything downstream —
      // the API query, `currentQuery` used for load-more paging, the analytics event and
      // the staleness check — should see the same trimmed phrase.
      const requestedPhrase = (phrase || "").trim();

      this.core.schedule(async (signal) => {
        this.showSkeleton();
        try {
          const data = await this.core.fetchPageSearch(requestedPhrase, null, signal);
          if (this.isStale(requestedPhrase)) return;

          const { html, restBatch } = await renderPageResults(requestedPhrase, data, this.translations, signal);
          if (this.isStale(requestedPhrase)) return;

          this.currentQuery = requestedPhrase;
          this.endCursor = data?.productSearch?.pageInfo?.endCursor || null;
          this.hasNextPage = !!data?.productSearch?.pageInfo?.hasNextPage;
          this.refreshResults();
          this.results.innerHTML = html;
          this.bindLoadMore();

          const totalCount = data?.productSearch?.totalCount || 0;
          this.core.trackSearchQuery(requestedPhrase, totalCount);

          if (typeof window.initVariantPickersInNewItems === "function") window.initVariantPickersInNewItems(this.results);
          if (typeof window.runAsyncActions === "function") window.runAsyncActions();

          if (restBatch.length) {
            const grid = this.results.querySelector("[data-search-page-grid]");
            appendRemainingProductCards(grid, restBatch, "search-cards-batch", signal).then(() => {
              if (this.isStale(requestedPhrase)) return;
              if (typeof window.initVariantPickersInNewItems === "function") window.initVariantPickersInNewItems(grid);
              if (typeof window.runAsyncActions === "function") window.runAsyncActions();
            });
          }

          const suggestions = requestedPhrase && !isCelebrityPickQuery(requestedPhrase)
            ? await this.core.fetchSuggestQueries(requestedPhrase, signal)
            : [];
          if (this.isStale(requestedPhrase)) return;
          this.field.renderSuggestions(
            suggestions.map((item) => ({
              url: `${window.Shopify?.routes?.root || "/"}search?q=${encodeURIComponent(item.text)}`,
              styled_text: item.styledText,
            }))
          );
        } catch (error) {
          if (error.name === "AbortError") return;
          console.log("search page error", error);
        }
      });
    }

    runSectionSearch(phrase) {
      // Normalized for the same reasons as runApiSearch above.
      const requestedPhrase = (phrase || "").trim();

      this.core.schedule(async (signal) => {
        this.showSkeleton();
        try {
          const html = await this.core.fetchSection(requestedPhrase, "search_results_grid", signal);
          if (this.isStale(requestedPhrase)) return;
          this.refreshResults();
          this.results.innerHTML = html.search_results_grid || "";
          const resultCountDoc = new DOMParser().parseFromString(html.search_results_grid || "", "text/html");
          const resultCount = resultCountDoc.querySelector("#hvg-search-results-count")?.value || 0;
          this.core.trackSearchQuery(requestedPhrase, resultCount);

          if (typeof window.setLoadMore === "function") window.setLoadMore();
          if (typeof window.runAsyncActions === "function") window.runAsyncActions();

          const suggestions = requestedPhrase ? await this.core.loadSuggestions(requestedPhrase) : [];
          if (this.isStale(requestedPhrase)) return;
          this.field.renderSuggestions(suggestions);
        } catch (error) {
          if (error.name === "AbortError") return;
          console.log("search page error", error);
        }
      });
    }

    bindLoadMore() {
      const button = this.results.querySelector("[data-search-page-load-more]");
      if (!button) return;
      button.addEventListener("click", this.onLoadMoreClick, { once: true });
    }

    async onLoadMoreClick() {
      if (!this.hasNextPage) return;

      const wrapper = this.results.querySelector("[data-search-page-load-more-wrapper]");
      const button = this.results.querySelector("[data-search-page-load-more]");
      const loader = this.results.querySelector("[data-search-page-loader]");
      const grid = this.results.querySelector("[data-search-page-grid]");

      if (button) button.style.display = "none";
      if (loader) loader.style.display = "block";

      try {
        const data = await this.core.fetchPageSearch(this.currentQuery, this.endCursor, null);
        const products = (data?.productSearch?.edges || []).map((edge) => edge.node);
        const chosenProducts = isCelebrityPickQuery(this.currentQuery) || isCategoryQuery(this.currentQuery)
          ? products
          : pickProducts(products, null).chosen;
        const cards = await fetchProductCardsBatch(chosenProducts.map((product) => product.handle), "search-cards-batch", null);
        appendProductCards(grid, cards);

        this.endCursor = data?.productSearch?.pageInfo?.endCursor || null;
        this.hasNextPage = !!data?.productSearch?.pageInfo?.hasNextPage;

        if (typeof window.initVariantPickersInNewItems === "function") window.initVariantPickersInNewItems(grid);
        if (typeof window.runAsyncActions === "function") window.runAsyncActions();
      } finally {
        if (loader) loader.style.display = "none";
        if (button) button.style.display = this.hasNextPage ? "inline-block" : "none";
        if (wrapper) wrapper.style.display = this.hasNextPage ? "flex" : "none";
        this.bindLoadMore();
      }
    }

    updateHistory(phrase) {
      const nextUrl = this.core.applySearchParams(new URL(window.location.href, window.location.origin), phrase).toString();
      window.history.replaceState(
        { additionalInformation: "Enroute search performed" },
        "Enroute - " + phrase + " search",
        nextUrl
      );
    }
  }

  class PredictiveSearchPopup extends HTMLElement {
    constructor() {
      super();
      this.core = new SearchCore();
      this.onFieldInput = this.onFieldInput.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onOverlayClick = this.onOverlayClick.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.form = this.querySelector("form");
      this.field = this.querySelector("search-field");
      this.closeButton = this.querySelector("[data-search-popup-close]");
      this.results = this.querySelector("[data-search-results]");
      this.popular = this.querySelector("[data-search-popular]");
      this.skeletonHTML = this.querySelector("[data-search-skeleton]")?.innerHTML.trim() || "";
      this.triggerSelector = this.dataset.triggerSelector || "[data-search-popup-trigger]";
      this.openClass = this.dataset.openClass || "on";

      if (!this.form || !this.field || !this.results || !this.popular) return;

      this.useApiSearch = this.dataset.useApiSearch !== "false";

      this.translations = {
        nothingWithBonus: this.dataset.tNothingWithBonus || "",
        viewAll: this.dataset.tViewAll || "View All",
      };

      this.bindTriggers();
      this.form.addEventListener("submit", this.onSubmit);
      this.field.addEventListener("search-field:input", this.onFieldInput);
      if (this.closeButton) {
        this.closeButton.addEventListener("click", this.onCloseClick);
      }
      // this.addEventListener("click", this.onOverlayClick);
      document.addEventListener("keydown", this.onDocumentKeydown);

      this.updatePanelPosition = () => {
        const header = this.closest("site-header")?.querySelector("header");
        if (header) this.style.setProperty("--search-panel-top", `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
      };
      this.headerObserver = new ResizeObserver(this.updatePanelPosition);
      const header = this.closest("site-header")?.querySelector("header");
      if (header) this.headerObserver.observe(header);
      const announcement = document.querySelector(".announcement-bar-container");
      if (announcement) this.headerObserver.observe(announcement);
      window.addEventListener("resize", this.updatePanelPosition);
      this.updatePanelPosition();
      this.showPopularState();
    }

    disconnectedCallback() {
      this.headerObserver?.disconnect();
      window.removeEventListener("resize", this.updatePanelPosition);
      if (this.form) {
        this.form.removeEventListener("submit", this.onSubmit);
      }
      if (this.field) {
        this.field.removeEventListener("search-field:input", this.onFieldInput);
      }
      if (this.closeButton) {
        this.closeButton.removeEventListener("click", this.onCloseClick);
      }
      // this.removeEventListener("click", this.onOverlayClick);
      document.removeEventListener("keydown", this.onDocumentKeydown);
    }

    bindTriggers() {
      document.querySelectorAll(this.triggerSelector).forEach((trigger) => {
        trigger.addEventListener("click", (event) => {
          event.preventDefault();
          if (this.classList.contains(this.openClass)) {
            this.toggle(trigger);
            return;
          }
          const pageInput = document.querySelector("predictive-search-page .search-field__input");
          if (pageInput) {
            pageInput.focus();
            return;
          }
          this.toggle(trigger);
        });
      });
    }

    setInputVisible(visible) {
      this.form.hidden = !visible;
      document.querySelectorAll(this.triggerSelector).forEach((trigger) => {
        trigger.setAttribute("aria-expanded", String(visible && this.classList.contains(this.openClass)));
      });
    }

    toggle(trigger) {
      const imageSearch = this.querySelector("image-search-flow");
      if (imageSearch?.activePanel === "results") {
        const visible = this.form.hidden;
        this.setInputVisible(visible);
        if (visible) this.field.focus();
        else trigger?.focus();
        return;
      }
      if (this.classList.contains(this.openClass)) this.close();
      else this.open();
    }

    onDocumentKeydown(event) {
      if (event.defaultPrevented) return;
      if (event.key === "Escape" && this.classList.contains(this.openClass)) {
        const menu = this.closest("site-header")?.querySelector("[data-mobile-menu].active");
        if (menu) {
          menu.querySelector("[data-mobile-menu-toggle]")?.click();
          return;
        }
        this.close();
      }
    }

    onCloseClick(event) {
      event.preventDefault();
      this.close();
    }

    onOverlayClick(event) {
      if (event.target !== this) return;
      // Inert content can retarget clicks to the popup; it is still not the overlay.
      const contentBounds = this.querySelector(":scope > .wrapper")?.getBoundingClientRect();
      if (contentBounds
        && event.clientX >= contentBounds.left && event.clientX <= contentBounds.right
        && event.clientY >= contentBounds.top && event.clientY <= contentBounds.bottom) return;
      if (this.querySelector("image-search-flow")?.active) return;
      this.close();
    }

    open() {
      this.updatePanelPosition();
      if (this.classList.contains(this.openClass)) {
        this.field.focus();
        return;
      }
      clearTimeout(this._hideTimer);
      this.hidden = false;
      this.classList.add(this.openClass);
      this.setInputVisible(true);
      window._erj_?.lockScroll?.();
      window.requestAnimationFrame(() => this.field.focus());
    }

    close() {
      if (!this.classList.contains(this.openClass)) return;
      this.core.clearPending();
      this.querySelector("image-search-flow")?.close(null);
      this.classList.remove(this.openClass);
      this.setInputVisible(true);
      document.querySelector(this.triggerSelector)?.focus();
      window._erj_?.unlockScroll?.();
      // Let the 0.4s opacity/visibility fade-out finish before removing from layout.
      clearTimeout(this._hideTimer);
      this._hideTimer = setTimeout(() => {
        if (!this.classList.contains(this.openClass)) this.hidden = true;
      }, 400);
    }

    onSubmit(event) {
      event.preventDefault();
      if (redirectSearchPage(this.core, this.field.value, true)) return;
      window.location.href = this.core.applySearchParams(
        new URL(window.Shopify.routes.root + "search", window.location.origin),
        this.field.value
      ).toString();
    }

    // Replace the previous results with placeholder cards as soon as a new request starts,
    // so the shopper never sees stale results sitting under an already-changed query.
    showSkeleton() {
      if (!this.skeletonHTML) return;
      this.results.innerHTML = this.skeletonHTML;
      this.results.hidden = false;
      this.popular.hidden = true;
    }

    onFieldInput(event) {
      const imageSearch = this.querySelector("image-search-flow");
      if (imageSearch?.active) imageSearch.close(null);
      const phrase = event.detail.value;

      if (redirectSearchPage(this.core, phrase)) return;

      if (!phrase.trim()) {
        this.showPopularState();
        this.core.clearPending();
        return;
      }

      if (this.useApiSearch || isCelebrityPickQuery(phrase) || isCategoryQuery(phrase)) {
        this.runApiSearch(phrase);
      } else {
        this.runSectionSearch(phrase);
      }
    }

    runApiSearch(phrase) {
      const requestedPhrase = phrase;

      this.core.schedule(async (signal) => {
        this.showSkeleton();
        try {
          const data = await this.core.fetchPopupSearch(requestedPhrase, signal);
          if (!this.field || this.field.value !== requestedPhrase) return;
          const { html, restBatch } = await renderPopupResults(requestedPhrase, data, this.translations, signal);
          if (!this.field || this.field.value !== requestedPhrase) return;
          this.results.innerHTML = html;
          this.results.hidden = false;
          this.popular.hidden = true;

          const totalCount = data?.productSearch?.totalCount || 0;
          this.core.trackSearchQuery(requestedPhrase, totalCount);

          if (typeof window.initVariantPickersInNewItems === "function") window.initVariantPickersInNewItems(this.results);
          if (typeof window.runAsyncActions === "function") window.runAsyncActions();

          if (restBatch.length) {
            const grid = this.results.querySelector("[data-search-popup-grid]");
            appendRemainingProductCards(grid, restBatch, "search-cards-batch-popup", signal, "col-12-xs col-8-sm col-6-md").then(() => {
              if (!this.field || this.field.value !== requestedPhrase) return;
              if (typeof window.initVariantPickersInNewItems === "function") window.initVariantPickersInNewItems(grid);
              if (typeof window.runAsyncActions === "function") window.runAsyncActions();
            });
          }

          const suggestions = isCelebrityPickQuery(requestedPhrase)
            ? []
            : await this.core.fetchSuggestQueries(requestedPhrase, signal);
          if (!this.field || this.field.value !== requestedPhrase) return;
          this.field.renderSuggestions(
            suggestions.map((item) => ({
              url: `${window.Shopify?.routes?.root || "/"}search?q=${encodeURIComponent(item.text)}`,
              styled_text: item.styledText,
            })),
            { appendSearchTrack: true }
          );
        } catch (error) {
          if (error.name === "AbortError") return;
          console.log("search popup error", error);
        }
      });
    }

    runSectionSearch(phrase) {
      const requestedPhrase = phrase;

      this.core.schedule(async (signal) => {
        this.showSkeleton();
        try {
          const html = await this.core.fetchSection(requestedPhrase, "search_results_popup", signal);
          if (!this.field || this.field.value !== requestedPhrase) return;
          this.results.innerHTML = html.search_results_popup || "";
          this.results.hidden = false;
          this.popular.hidden = true;

          const resultCountDoc = new DOMParser().parseFromString(html.search_results_popup || "", "text/html");
          const resultCount = resultCountDoc.querySelector("#hvg-search-results-count")?.value || 0;
          this.core.trackSearchQuery(requestedPhrase, resultCount);

          const suggestions = await this.core.loadSuggestions(requestedPhrase);
          if (!this.field || this.field.value !== requestedPhrase) return;
          this.field.renderSuggestions(suggestions, { appendSearchTrack: true });
        } catch (error) {
          if (error.name === "AbortError") return;
          console.log("search popup error", error);
        }
      });
    }

    showPopularState() {
      this.popular.hidden = false;
      this.results.hidden = true;
      this.results.innerHTML = "";
      this.field.clearSuggestions();
    }
  }

  window.EnrouteSearch = window.EnrouteSearch || {};
  window.EnrouteSearch.SearchCore = SearchCore;
  window.EnrouteSearch.renderPopupResults = renderPopupResults;
  window.EnrouteSearch.renderProductHandles = renderProductHandles;
  window.EnrouteSearch.appendRemainingProductCards = appendRemainingProductCards;

  if (!window.customElements.get("search-field")) {
    window.customElements.define("search-field", SearchField);
  }

  if (!window.customElements.get("predictive-search-page")) {
    window.customElements.define("predictive-search-page", PredictiveSearchPage);
  }

  if (!window.customElements.get("predictive-search-popup")) {
    window.customElements.define("predictive-search-popup", PredictiveSearchPopup);
  }
})();
